import './index.css'
import { defineComponent, ref, VNode, onMounted } from 'vue'
import Icon from './icon'

export interface IToastOptions {
  type?: TOAST_TYPE // toast 类型
  mask?: MASK_TYPE // mask 类型
  duration?: number // 持续时间，为 0 时不自动隐藏
  render?: () => VNode // type 为 CUSTOM 时，自定义 icon 内容
  iconName?: string // type 为 ICON 时，assets/icons 里 svg 的文件名
  src?: string // type 为 IMAGE 时，传入的图片链接地址
  white?: boolean // 白底或黑底
  message?: string // 传入的 toast 提示信息
}

export enum MASK_TYPE {
  TRANSPARENT = 'TRANSPARENT',
  WHITE = 'WHITE',
}

export enum TOAST_TYPE {
  CUSTOM = 'CUSTOM',
  ICON = 'ICON',
  IMAGE = 'IMAGE',
  MESSAGE = 'MESSAGE',
}

export default defineComponent({
  setup() {
    let timer: NodeJS.Timeout
    const state = ref(false)
    const options = ref<IToastOptions>({
      mask: MASK_TYPE.TRANSPARENT,
      duration: 3000,
      white: false,
    })

    const toastMaskClass = computed(() => [
      '_toast-mask',
      options.value.mask === MASK_TYPE.WHITE ? '_toast-white-mask' : '_toast-transparent-mask',
    ])
    const toastWrapClass = computed(() => [
      '_toast-wrap',
      (!options.value.type || options.value.type === TOAST_TYPE.MESSAGE) && '_toast-msg-wrap',
      options.value.white && '_toast-white-wrap',
    ])
    const toastMaskStyle = computed(() => {
      return `display: ${state.value ? 'block' : 'none'}`
    })

    const show = (opt?: IToastOptions | string) => {
      state.value = true
      if (!opt) return
      if (typeof opt === 'string') {
        options.value.message = opt
      } else {
        options.value = Object.assign(
          {
            mask: MASK_TYPE.TRANSPARENT,
            duration: 3000,
            white: false,
          },
          opt,
        )
        console.log(options.value, opt)
      }
    }
    const hide = () => {
      state.value = false
    }

    watch(
      () => [state.value, options.value],
      () => {
        clearTimeout(timer)
        if (state.value && options.value.duration && options.value.duration > 0) {
          timer = setTimeout(() => {
            hide()
          }, options.value.duration)
        }
      },
    )

    onMounted(() => {
      clearTimeout(timer)
    })

    return {
      state,
      options,
      toastMaskClass,
      toastMaskStyle,
      toastWrapClass,
      show,
      hide,
    }
  },
  render() {
    let icon: VNode | null
    switch (this.options?.type) {
      case TOAST_TYPE.CUSTOM:
        icon = this.options.render?.() || this.slots.default() || null
        break
      case TOAST_TYPE.ICON:
        icon = h(Icon, {
          name: this.options?.iconName ?? '',
        })
        break
      case TOAST_TYPE.IMAGE:
        icon = h('img', { src: this.options.src })
        break
      case TOAST_TYPE.MESSAGE:
      default:
        icon = null
        break
    }
    return h(
      'div',
      {
        class: this.toastMaskClass,
        style: this.toastMaskStyle,
        ontouchstart: (e: any) => e.preventDefault(),
      },
      [
        h('div', { class: this.toastWrapClass }, [
          icon && h('span', { class: '_toast-icon' }, icon),
          h('p', { class: '_toast-message' }, this.options.message),
        ]),
      ],
    )
  },
})
